import React, { useContext, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from 'react-bootstrap/AccordionContext';
import styled from "@emotion/styled";
import {css} from "@emotion/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleDown } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons'

const SectionBackground = styled.div`
  background-color : ${props => props.theme.colors.white};
  color : ${props => props.theme.colors.gray_dark};
  padding-bottom:50px;
`

const CardBody = styled(Card.Body)`
  font: 20px/22px Roboto;
`

const AccordionTitle = styled.div`
  font: 58px/62px Abril Fatface;
  color : ${props => props.theme.colors.secondary_green};
  margin-bottom: 30px;
  @media(max-width:767px){
    font: 2.5rem/3rem Abril Fatface;
  }
`

const AccordionSubtitle = styled.div`
  font: 28px/32px Abril Fatface;
  color : ${props => props.theme.colors.gray_dark};
`

const AccordionTitleContent = styled.div`
  font: 20px/22px Roboto;
  margin-top: 10px;
  margin-bottom: 20px;
`

const CardAccordion = styled(Card)`
  border: 2px solid ${props => props.theme.colors.gray_border};
  border-left:none;
  border-right:none;
  .card-header {
    padding:0;
    background-color: ${props => props.theme.colors.white};
    border-bottom:none;
  }
  .card-body {
    text-align: justify;
    padding-left:5px;
    padding-top:0;
    padding-bottom:15px;
    span {
      margin-left:15px;
    }
    div {
      margin-top:10px;
    }
  }
  .row-video {
    img {
      width:122px;
      height:70px;
      object-fit:contain;
    }
  }
  .col-video{
    @media(min-width:1200px) {
      padding-right:0;
    }
  }
`
const FAArrow = styled(FontAwesomeIcon)`
  font-size:1.5rem;
  color: ${props => props.theme.colors.primary_violet};
  &:hover, &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.colors.primary_violet_dark};
  }
`

const FACheck = styled(FontAwesomeIcon)`
  font-size:1rem;
  color: ${props => props.theme.colors.secondary_green10};
`

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <div
      css={css`
        font: Bold 20px/28px Roboto;
        outline:none;
        padding-top:30px;
        padding-bottom:30px};
        @media(max-width:767px){
          padding-top:15px;
          padding-bottom:15px};
        }
      `}
      onClick={decoratedOnClick}
      onKeyDown={decoratedOnClick}
      role="button"
      tabIndex={0}
    >
      <Row>
        <Col xs="10" md="11">
          {children}
        </Col>
        <Col xs="2" md="1" className="d-flex justify-content-end">
          <FAArrow icon={isCurrentEventKey ? faArrowAltCircleDown : faArrowAltCircleRight} />
        </Col>
      </Row>
    </div>
  );
}

export default function FaqSection5() {
  let activeKey = "0";

  if (typeof window !== `undefined`) {  
    let params = new URLSearchParams(document.location.search);
    let getactiveKey = params.get("defaultActiveKey");
    console.log("activekey:", activeKey);
    if (getactiveKey!==null){
      activeKey = getactiveKey;
    }
  }
useEffect(() => {
  if (typeof window !== `undefined`) {
  
  let params = new URLSearchParams(document.location.search);
  let getanchorid = params.get("id");
    
    if (getanchorid != null){
      let anchorid = getanchorid;
      console.log("anchorid:", anchorid);
      let ref = document.getElementById(anchorid);
      ref.scrollIntoView({
        behavior:'smooth',
        block:'center',
        inline:'center'
      });
      console.log("scrolling");
  }
}
});
  return (      
    <SectionBackground>
      <Container>
        <Row>
          <Col lg="12">
          <Accordion defaultActiveKey={activeKey} css={css`margin-bottom:25px;`}>
            {/* <AccordionSubtitle>WomenWorks Services :</AccordionSubtitle> */}
            <AccordionTitle>WomenWorks Services :</AccordionTitle>
            {/* <AccordionTitle>Pre-Mentorship</AccordionTitle> */}
            <AccordionSubtitle>Pre-Mentorship</AccordionSubtitle>
            <AccordionTitleContent>We offer free 15-minute consultation sessions to help prospective mentees know more about our services and find the most suitable program for their needs.</AccordionTitleContent>
            <CardAccordion id="section5-point1">
              <Card.Header>
                <ContextAwareToggle eventKey="0">1. Who is this best for?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <CardBody>
                <Col>
                    <Row>
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Anyone who would like to know more about mentorship and its benefits
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Prospective mentees who need help in choosing programs, planning their sessions, or picking the most suitable mentor
                        </Col>
                    </Row>
                    <Row>
                        <i css={css`margin-top:10px;`}>*Please note that Pre-Mentorship Consultation can only be used to answer questions related to mentorship itself or about our services. If you wish to get suggestions on how to solve your problems, we advise that you proceed directly to mentorship registration.</i>
                    </Row>
                 </Col>
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            <CardAccordion id="section5-point2">
              <Card.Header>
                <ContextAwareToggle eventKey="1">2. How does it work?</ContextAwareToggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <CardBody>
                <Col>
                    <Row>
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Sign up for a 15-minute consultation at bit.ly/prementorshipWW
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Receive an email confirming our team member you will consult to (tip: check in Spam!)
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Depending on your agreement, confirm a date for your conference call or contact our team member on WhatsApp
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Ask whatever questions you have about WomenWorks!
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="auto" css={css`padding-right:0;`}>
                            <FACheck icon={faCheck} />
                        </Col>
                        <Col css={css`padding-left:7px;font: 20px/22px Roboto;`}>
                            Once you’re finished, do take the time to think about what program would be most suitable, or whether a mentorship is the best solution for you. No need to rush ;)
                        </Col>
                    </Row>
                </Col>
                </CardBody>
              </Accordion.Collapse>
            </CardAccordion>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </SectionBackground>
  )
}